class NewsletterImages extends HTMLElement {
  constructor() {
    super();
    this.mobSubmissionButton = this.querySelector(".mob-newsletter-submission");
    this.newsletterForm = this.querySelector(".newsletter-form");
    this.init();
  }

  init() {
    if (this.mobSubmissionButton == null) return;
    this.triggerForm();
  }

  triggerForm() {
    this.mobSubmissionButton.addEventListener("click", e => {
      e.preventDefault();
      this.newsletterForm.submit();
    });
  }
}

customElements.define("newsletter-images", NewsletterImages);
